export default "https://legacy.eskolare-development.com/images/horizontal-color.png";